module.exports = __webpack_public_path__ + "static/media/29.82b5958e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/29.jpg
// module id = 398
// module chunks = 0